import { call, put, takeEvery } from 'redux-saga/effects';
import * as onlineStoreApi from 'api/onlineStore';
import {
  ONLINE_STORE_CONNECT_GOOGLE_SHOP,
  ONLINE_STORE_CONNECT_GOOGLE_EMAIL,
} from 'actions/onlineStore/constants';
import * as onlineStoreAction from 'actions/onlineStore';
import * as actionNotification from 'actions/notifications';
import * as googleClevertap from 'clevertap/onlineStore/google';
import * as action from 'actions';
import {
  ONLINE_STORE_CHANNEL,
  CONNECT_GOOGLE_SOURCE,
} from 'utils/onlineStoreUtils';

const clevertapMap = {
  [CONNECT_GOOGLE_SOURCE.LANDING_PAGE]: {
    success: googleClevertap.googleConnectAccountSuccess,
    failure: googleClevertap.googleConnectAccountFailure,
  },
  [CONNECT_GOOGLE_SOURCE.OUTLET_LIST_PAGE]: {
    success: googleClevertap.googleConnectAnotherOutletSuccess,
    failure: googleClevertap.googleConnectAnotherOutletFailure,
  },
};

function* connectGoogleShopFlow({ payload }) {
  const { outletId, outletName, source } = payload;
  const clevertap = clevertapMap[source];

  try {
    yield put(action.showLoadingSpinner(true));
    const { data } = yield call(
      onlineStoreApi.createShop,
      ONLINE_STORE_CHANNEL.GOOGLE,
      outletId
    );

    clevertap.success();
    yield put(onlineStoreAction.pageRequest(ONLINE_STORE_CHANNEL.GOOGLE));
    yield put(onlineStoreAction.closeOutletModal());
    yield put(
      actionNotification.success(
        `${outletName} has been successfully connected to Google.`
      )
    );

    yield put(
      onlineStoreAction.startSyncingProductValidationFlow(data.id, false)
    );
  } catch (error) {
    clevertap.failure(error.message);
    yield put(actionNotification.error(error.message));
  } finally {
    yield put(action.showLoadingSpinner(false));
  }
}

function* connectGoogleEmail({ payload }) {
  const { shop, email } = payload;

  try {
    yield put(action.showLoadingSpinner(true));
    yield call(onlineStoreApi.registerMerchantAccount, shop.id, email);
    yield put(onlineStoreAction.closeConnectGoogleEmailModal());
    yield put(onlineStoreAction.pageRequest(ONLINE_STORE_CHANNEL.GOOGLE));
  } catch (error) {
    yield put(actionNotification.error(error.message));
  } finally {
    yield put(action.showLoadingSpinner(false));
  }
}

export default function* googleSaga() {
  yield takeEvery(ONLINE_STORE_CONNECT_GOOGLE_SHOP, connectGoogleShopFlow);
  yield takeEvery(ONLINE_STORE_CONNECT_GOOGLE_EMAIL, connectGoogleEmail);
}
